import classes from '@/App.module.scss';
import CentrifugeReports from '@/components/CentrifugeReports/CentrifugeReports';
import { ContentSkeleton } from '@/components/LoadingSkeleton/LoadingSkeleton';
import { Suspense } from 'react';

export default function PageCentrifugeReports() {
  return (
    <div className={classes.reportsPage}>
      <div className={classes.reportTable}>
        <Suspense fallback={<ContentSkeleton />}>
          <CentrifugeReports />
        </Suspense>
      </div>
    </div>
  );
}
